import './style.scss'
import RadioGroup from '../../components/RadioGroup/RadioGroup'
import {
  COGNUS_REPOSITORY_OPTIONS,
  COGNUS_REPOSITORY_OPTIONS_COMMONS,
  COGNUS_REPOSITORY_OPTIONS_EXTRA
} from './constants'
import { useEffect, useMemo, useState } from 'react'
import { AvailableForEvaluation } from './AvailableForEvaluation/AvailableForEvaluation'
import { OpportunityAnalysis } from './OpportunityAnalysis/OpportunityAnalysis'
import CognusRepositoryPopupProvider from './Providers/CognusRepositoryPopupProvider'
import CognusRepositoryActions from './Providers/CognusRepositoryActions'
import { RequestForAnalysis } from './RequestForAnalysis/RequestForAnalysis'
import { InitialClinicalReviewAction } from './InitiateClinicalReview/Action'
import { useNavigate } from 'react-router'
import { safeString } from 'helper/common'
import { routes } from '../../router'
import useRouter from '../../hooks/useRouter'
import { useSelector } from 'react-redux'
import { getUser } from '../../redux/store/user/getters'
import defineAbilityFor from '../Permission/ability'

export const CognusRepository = () => {
  const navigate = useNavigate()
  const { query } = useRouter()
  const user = useSelector(getUser)
  const [activeSubTab, setActiveSubTab] = useState('')
  const [isCanRunClinicalReview, setIsCanRunClinicalReview] = useState(false)
  const handleTabs = (e) => {
    setActiveSubTab(e)
  }

  const ability = defineAbilityFor(user.role, user, '')

  const ALL_COGNUS_REPOSITORY_OPTIONS = useMemo(
    () => COGNUS_REPOSITORY_OPTIONS(ability),
    [ability]
  )
  const COGNUS_REPOSITORY_OPTIONS_AVAILABLE = useMemo(() => {
    return ALL_COGNUS_REPOSITORY_OPTIONS.filter((option) => !option.disabled)
  }, [ALL_COGNUS_REPOSITORY_OPTIONS])

  const ALL_COGNUS_REPOSITORY_OPTIONS_EXTRA = useMemo(
    () => COGNUS_REPOSITORY_OPTIONS_EXTRA(ability, user),
    [ability, user]
  )
  const COGNUS_REPOSITORY_OPTIONS_EXTRA_AVAILABLE = useMemo(() => {
    return ALL_COGNUS_REPOSITORY_OPTIONS_EXTRA.filter(
      (option) => !option.disabled
    )
  }, [ALL_COGNUS_REPOSITORY_OPTIONS_EXTRA])

  useEffect(() => {
    if (query?.subtab) {
      setActiveSubTab(query?.subtab)
    } else {
      setActiveSubTab(
        user.commons
          ? COGNUS_REPOSITORY_OPTIONS_COMMONS[0]?.value
          : COGNUS_REPOSITORY_OPTIONS_AVAILABLE[0]?.value
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query?.subtab, user])

  useEffect(() => {
    if (query?.subtab) {
      setActiveSubTab(safeString(query?.subtab))
      navigate(routes.contracts + routes.centralRepository, {
        replace: true
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query?.subtab])

  return (
    <CognusRepositoryActions>
      <CognusRepositoryPopupProvider>
        <div className="cognus-repository-container">
          <div className="cognus-repository-container__header row space-between">
            <span className="cognus-repository-container__header__btn row">
              {user?.commons ? (
                <RadioGroup.Buttons
                  options={COGNUS_REPOSITORY_OPTIONS_COMMONS}
                  defaultValue={activeSubTab}
                  onChange={handleTabs}
                />
              ) : (
                <>
                  <RadioGroup.Buttons
                    options={COGNUS_REPOSITORY_OPTIONS_AVAILABLE}
                    defaultValue={activeSubTab}
                    onChange={handleTabs}
                  />
                  {
                    <RadioGroup.Buttons
                      className="requests-for-analysis-btn"
                      options={COGNUS_REPOSITORY_OPTIONS_EXTRA_AVAILABLE}
                      defaultValue={activeSubTab}
                      onChange={handleTabs}
                    />
                  }
                </>
              )}
            </span>
            {activeSubTab === ALL_COGNUS_REPOSITORY_OPTIONS[1].value &&
              isCanRunClinicalReview && <InitialClinicalReviewAction />}
          </div>
          {activeSubTab === ALL_COGNUS_REPOSITORY_OPTIONS[0].value && (
            <AvailableForEvaluation />
          )}
          {activeSubTab === ALL_COGNUS_REPOSITORY_OPTIONS[1].value && (
            <OpportunityAnalysis
              setIsCanRunClinicalReview={setIsCanRunClinicalReview}
            />
          )}
          {COGNUS_REPOSITORY_OPTIONS_EXTRA_AVAILABLE.some(
            (option) => option.value === activeSubTab
          ) && <RequestForAnalysis />}
        </div>
      </CognusRepositoryPopupProvider>
    </CognusRepositoryActions>
  )
}
